module.exports = __webpack_public_path__ + "static/media/logo.89ac5c16.svg";